import { Button, Divider, Form, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { updateRoadmapStage } from "../../repository/data.repository";
import { RoadmapStage } from "../../repository/data.default";
import DynamicForm from "../../controls/DynamicForm";
import { DynamicSchema } from "../../controls/DynamicForm.default";
import RoadmapRequirementsManager from "./RoadmapRequirementsManager";

export interface RoadmapStagePanelProps {
  readonly stage: RoadmapStage;
  readonly onChanged: () => void | Promise<void>;
}

const stageSchema: DynamicSchema = {
  groups: [
    {
      controls: [
        {
          type: "textbox",
          name: "name",
          label: "Name",
          rules: [{ required: true, message: "Name is required" }],
        },
        { type: "numberbox", name: "order", label: "Order" },
        {
          type: "togglebox",
          name: "isPublished",
          label: "Published",
          checkedText: "Published",
          unCheckedText: "Draft",
          tooltip: "Draft stages are hidden from companies and excluded from their journey.",
        },
        { type: "textbox", name: "shortDescription", label: "Short Description" },
        { type: "editorbox", name: "description", label: "Description", rows: 4 },
        { type: "editorbox", name: "stepsDescription", label: "Steps Description", rows: 4 },
      ],
    },
  ],
};

// Detail pane for the selected stage: editable details + its requirements + its template files.
function RoadmapStagePanel(props: RoadmapStagePanelProps) {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    form.setFieldsValue({
      name: props.stage.name,
      order: props.stage.order,
      isPublished: props.stage.isPublished,
      shortDescription: props.stage.shortDescription,
      description: props.stage.description,
      stepsDescription: props.stage.stepsDescription,
    });
  }, [props.stage, form]);

  function onSave(): void {
    form.validateFields().then(() => {
      setSaving(true);
      const v = form.getFieldsValue();
      updateRoadmapStage({
        uid: props.stage.uid,
        rowVersion: props.stage.rowVersion,
        name: v.name,
        order: Number(v.order ?? 0),
        isPublished: !!v.isPublished,
        shortDescription: v.shortDescription,
        description: v.description,
        stepsDescription: v.stepsDescription,
      })
        .then(() => props.onChanged())
        .catch(() => message.error("Couldn't save the stage"))
        .finally(() => setSaving(false));
    });
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-row items-center justify-between">
        <Typography.Text strong>Stage Details</Typography.Text>
        <Button type="primary" loading={saving} onClick={onSave}>
          Save Stage
        </Button>
      </div>
      <DynamicForm className="w-auto" form={form} schema={stageSchema} />

      <Divider className="my-2" />
      <RoadmapRequirementsManager stageUid={props.stage.uid} onChanged={props.onChanged} />
    </div>
  );
}

export default RoadmapStagePanel;
